import {BaseService} from "../infrastructure/domain-services/base-service";
import {makeObservable, observable} from "mobx";

export class VendorConsentProvider extends BaseService {
  vendorId: Number;
  shouldSupportConsent: Boolean;
  isProviderEnable: Boolean;
  @observable isVendorConsentGranted: Boolean;

  constructor(vendorId: Number, shouldSupportConsent: Boolean) {
    super();

    this.isVendorConsentGranted = null;

    makeObservable(this);

    this.vendorId = vendorId;
    this.shouldSupportConsent = shouldSupportConsent;

    this.initEventListener()
  }

  setVendorConsent(): Boolean {
    this.isVendorConsentGranted = !this.shouldSupportConsent || window.didomiState?.didomiVendorsConsent.includes(this.vendorId);
    //const isVendorConsentUnknown: Boolean = window.didomiState?.didomiVendorsConsentUnknown.includes(this.vendorId);

    this.isProviderEnable = true;
  }

  initEventListener() {
    this.setVendorConsent()

    const setVendorConsent = this.setVendorConsent.bind(this);
    const init = this.init.bind(this);

    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push(function () {
      window.didomiEventListeners?.push({
        event: "consent.changed",
        listener: () => {
          setVendorConsent();
          init();
        }
      });
    });

  }
}